module.exports = __webpack_public_path__ + "static/img/partner_15.cc09b52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us/partners/partner_15.png
// module id = VtdY
// module chunks = 0